import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import posts from './posts';
import usePageMeta from '../../hooks/usePageMeta';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(12),
    marginBottom: theme.spacing(8),
    textAlign: 'left',
  },
  backLink: {
    cursor: 'pointer',
    display: 'inline-block',
    marginBottom: theme.spacing(4),
  },
  date: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    display: 'block',
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  sectionHeading: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  paragraph: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.8,
  },
  cta: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(4),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.action.hover,
  },
}));

export default function BlogPost(props) {
  const classes = useStyles();
  const history = useHistory();
  const slug = props.match.params.slug;
  const post = posts.find((p) => p.slug === slug);
  usePageMeta(post?.title, post?.summary);

  if (!post) {
    return (
      <Container maxWidth="md" className={classes.root}>
        <Typography variant="h4">Article not found.</Typography>
        <Link className={classes.backLink} onClick={() => history.push('/blog')} color="primary">
          Back to Blog
        </Link>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" className={classes.root}>
      <Link className={classes.backLink} onClick={() => history.push('/blog')} color="primary">
        ← Back to Blog
      </Link>

      <Typography variant="caption" className={classes.date}>
        {post.date}
      </Typography>

      <Typography variant="h3" className={classes.title} gutterBottom>
        {post.title}
      </Typography>

      {post.content.map((block, i) => {
        if (block.type === 'heading') {
          return (
            <Typography key={i} variant="h5" className={classes.sectionHeading} gutterBottom>
              {block.text}
            </Typography>
          );
        }
        return (
          <Typography key={i} variant="body1" className={classes.paragraph}>
            {block.text}
          </Typography>
        );
      })}

      <div className={classes.cta}>
        <Typography variant="h6" gutterBottom>
          Ready to take control?
        </Typography>
        <Typography variant="body1">
          The Warrior Tribe Chrome extension automatically blocks adult websites and tracks your progress with streaks and XP.{' '}
          <Link href="/" color="primary">
            Learn more and download the extension.
          </Link>
        </Typography>
      </div>
    </Container>
  );
}
